<template>
  <v-container fluid class="pa-0 ml-2" fill-height>
    <v-dialog v-model="showInvite" max-width="600px" @click:outside="dismissInvite">
      <v-card>
        <v-toolbar color="secondary" dark>
          <h2>Invite Participant</h2>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-text-field label="Email" required v-model="inviteEmail"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field label="Message" v-model="inviteMessage"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="btnInvite = -1" v-if="!inviteSending">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="sendInvite" :loading="inviteSending">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-toolbar flat dense>
      <v-spacer/>
      <template v-for="participant in conversation.participants">
        <v-avatar :key="participant.doc.id" class="mr-2" :size="35" v-if="avatarImage(participant.entity)">
            <v-img :src="avatarImage(participant.entity)"></v-img>
        </v-avatar>
        <v-avatar :key="participant.doc.id" color="accent" class="mr-2" :size="35" v-else>
          {{ avatarLetters(participant.entity) }}
        </v-avatar>
      </template>
      <v-divider vertical class="ml-3 mr-3"></v-divider>
      <v-btn-toggle v-model="btnInvite" dense borderless class="mr-2">
        <v-btn icon dense small>
          <v-icon small style="opacity: 0.6">fa-user-plus</v-icon>
        </v-btn>
      </v-btn-toggle>
      <v-btn-toggle v-model="btnFiles" dense borderless>
        <v-btn icon dense small @click="loadItems()">
          <v-icon small>far fa-file</v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-toolbar>
    </v-row>
    <v-row no-gutters class="mr-2 pr-2" style="position: relative;">
      <v-navigation-drawer v-model="showDrawer" absolute right :width="400">
          <v-card flat>
            <v-divider></v-divider>
            <v-toolbar flat dense>
              <v-subheader>Files</v-subheader>
              <v-spacer></v-spacer>
              <v-btn icon tile @click="selectFile">
                <v-icon small>fa-upload</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
              <v-progress-linear
                v-if="loadingItems"
                indeterminate
                color="accent darken-2"
              ></v-progress-linear>
            <v-file-input v-if="showUploadInput"
              small-chips
              dense
              class="pa-4"
              show-size
              clear-icon="mdi-close"
              placeholder="Upload a Fille"
              prepend-icon="mdi-paperclip"></v-file-input>
            <v-list>
              <v-list-item v-for="(item) in conversation.items" :key=item.id dense>
                <v-list-item-icon><v-icon>{{ formatMimeTypeIcon(item) }}</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                  <v-list-item-subtitle>Created: {{ formatUploadDate(item) }}</v-list-item-subtitle>
                  <v-list-item-subtitle>Size: {{ formatItemSize(item) }}</v-list-item-subtitle>
                  <v-list-item-subtitle>By: {{ formateItemOwner(item) }}</v-list-item-subtitle>
                  <v-progress-linear
                    v-if="item.uploading"
                    indeterminate
                    color="accent darken-2"
                  ></v-progress-linear>
                </v-list-item-content>
                  <v-btn
                  icon
                  :loading="(itemDelete.find(i => i === item.id)) ? true : false"
                  @click="deleteItem(item)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
              </v-list-item>
            </v-list>
          </v-card>
        </v-navigation-drawer>
      <v-col cols="chatCols">
        <Chat :conversation="conversation" :cid="cid" @joinRTC="joinRTC"></Chat>
      </v-col>
      <v-col cols="3" v-if="activeRTC">
        <RTCSession @leave="leaveRTC" :sessionId="activeRTC" :conversationId="cid"></RTCSession>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Chat from '@/components/Chat.vue'
import RTCSession from '@/components/RTCSession.vue'
import { avatarImage, avatarLetters, primaryContactEmail } from '@/utils/entityDisplay'
import moment from 'moment'
import prettyBytes from 'pretty-bytes'

export default {
  name: 'Conversation',
  data () {
    return {
      showRtc: false,
      showUploadInput: false,
      loadingItems: false,
      btnFiles: -1,
      btnInvite: -1,
      itemDelete: [],
      inviteEmail: '',
      inviteMessage: '',
      inviteSending: false,
      activeRTC: ''
    }
  },
  components: { Chat, RTCSession },
  props: { cid: String, conversations: Array },
  async mounted () {
    this.$emit('subscribeConversation', this.cid)
    this.lastCid = this.cid
  },
  async updated () {
    if (this.lastCid !== this.cid) {
      this.$emit('subscribeConversation', this.cid)
      console.log('updated called')
      this.lastCid = this.cid
      this.showRtc = false
    }
  },
  methods: {
    async sendInvite () {
      this.inviteSending = true
      try {
        await this.$store.dispatch('hearro/sendConversationInvite', { invitee: this.inviteEmail, conversationId: this.cid, message: this.inviteMessage })
        this.$store.dispatch('hearro/loadConversationInvites')
        this.btnInvite = false
        this.inviteEmail = ''
        this.inviteMessage = ''
      } catch (e) {
        console.log(e)
      } finally {
        this.inviteSending = false
      }
    },
    joinRTC (sessionId) {
      console.log('join Rtc', sessionId)
      this.activeRTC = sessionId
    },
    leaveRTC () {
      this.activeRTC = ''
    },
    chatCols () {
      return this.showRtc ? 9 : 12
    },
    avatarImage (e) {
      console.log('avatar image', e)
      return avatarImage(e)
    },
    avatarLetters (e) {
      return avatarLetters(e)
    },
    primaryContactEmail (e) {
      return primaryContactEmail(e)
    },
    formatUploadDate (item) {
      if (item.meta.created) {
        return moment(item.meta.crated).format('MMM Do YY')
      }
      return ''
    },
    formatItemSize (item) {
      return prettyBytes(item.size || 0)
    },
    formateItemOwner (item) {
      const p = this.conversation.participants.find(p => {
        return p.doc.id === item.owner_id
      })
      return this.primaryContactEmail(p.entity)
    },
    formatMimeTypeIcon (item) {
      if (!item.mime_type) {
        return 'far fa-file'
      }
      const iconClasses = {
        // Media
        image: 'far fa-file-image',
        audio: 'far fa-file-audio',
        video: 'far fa-file-video',
        // Documents
        'application/pdf': 'far fa-file-pdf',
        'application/msword': 'far fa-file-word',
        'application/vnd.ms-word': 'far fa-file-word',
        'application/vnd.oasis.opendocument.text': 'far fa-file-word',
        'application/vnd.openxmlformats-officedocument.wordprocessingml':
      'far fa-file-word',
        'application/vnd.ms-excel': 'far fa-file-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml':
      'far fa-file-excel',
        'application/vnd.oasis.opendocument.spreadsheet': 'far fa-file-excel',
        'application/vnd.ms-powerpoint': 'far fa-file-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml':
      'far fa-file-powerpoint',
        'application/vnd.oasis.opendocument.presentation': 'far fa-file-powerpoint',
        'text/plain': 'far fa-file-text',
        'text/html': 'far fa-file-code',
        'application/json': 'far fa-file-code',
        // Archives
        'application/gzip': 'far fa-file-archive',
        'application/zip': 'far fa-file-archive'
      };

      for (var key in iconClasses) {
        // eslint-disable-next-line no-prototype-builtins
        if (iconClasses.hasOwnProperty(key)) {
          if (item.mime_type.search(key) === 0) {
            // Found it
            return iconClasses[key];
          }
        } else {
          return 'far fa-file';
        }
      }

      return 'far fa-file';
    },
    async deleteItem (item) {
      this.itemDelete.push(item.id)
      try {
        await this.$store.dispatch('hearro/deleteConversationItem', { conversationId: this.cid, itemId: item.id })
      } catch (e) {
        console.log('item delete failed', e)
      } finally {
        await this.loadItems()
        const itemDeleteIndex = this.itemDelete.findIndex(i => { return i === item.id })
        this.itemDelete.splice(itemDeleteIndex, 1)
      }
    },
    async loadItems () {
      this.loadingItems = true
      try {
        await this.$store.dispatch('hearro/loadConversationItems', { conversationId: this.cid })
      } catch (e) {
        console.log(e)
      } finally {
        this.loadingItems = false
      }
    },
    async selectFile () {
      const input = document.createElement('input');
      input.type = 'file';

      input.onchange = async e => {
        // getting a hold of the file reference
        var file = e.target.files[0];

        console.log(file)
        // // setting up the reader
        // var reader = new FileReader();
        // reader.readAsText(file, 'UTF-8');

        // // here we tell the reader what to do when it's done reading...
        // reader.onload = readerEvent => {
        //   var content = readerEvent.target.result; // this is the content!
        //   console.log(content);
        // }
        await this.$store.dispatch('hearro/saveConversationItemData', { conversationId: this.cid, file })
        // await this.loadItems()
      }

      input.click();
    },
    dismissInvite () {
      this.btnInvite = -1
    }
  },
  computed: {
    showDrawer () {
      return (this.btnFiles === 0)
    },
    showInvite () {
      return (this.btnInvite === 0)
    },
    conversation () {
      return this.conversations.filter(c => c.data.id === this.cid)[0]
    }
  }
}
</script>
